import React from 'react'

function CreateTiclet() {
    return (
        <>
            <div className='container ms-5 ps-5'>
                <div className='row px-5 mt-5 '>
                    <h1 className='fs-4 text-muted mb-3 pb-3'>To create a ticket, select a relevant topic</h1>
                    <div className='col-md-4'>
                        <p className='fs-5'><i class="fa fa-plus-circle mx-2" aria-hidden="true"></i>Account Opening</p>
                        <ul className='lh-lg' style={{lineHeight:"20px"}}>
                            <li >
                                <a href='' className='text-decoration-none'>Getting started</a>

                            </li>

                            <li>
                                <a href='' className='text-decoration-none'>Online</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Offline</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Charges</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Company, Partnership and HUF</a>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-4'>
                    <p className='fs-5'><i class="fa fa-user-o mx-2" aria-hidden="true"></i>Your StocXpert Account</p>
                        <ul className='lh-lg' style={{lineHeight:"20px"}}>
                            <li >
                                <a href='' className='text-decoration-none'>Getting </a>

                            </li>

                            <li>
                                <a href='' className='text-decoration-none'>Online</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Offline</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Charges</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Company, Partnership and HUF</a>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-4'>
                    <p className='fs-5'><i class="fa fa-signal mx-2" aria-hidden="true"></i>Trading and Markets</p>
                        <ul className='lh-lg' style={{lineHeight:"20px"}}>
                            <li >
                                <a href='' className='text-decoration-none'>Getting started</a>

                            </li>

                            <li>
                                <a href='' className='text-decoration-none'>Online</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Offline</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Charges</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Company, Partnership and HUF</a>
                            </li>
                        </ul>
                    </div>

                </div>
                <div className='row p-5 mb-5'>
                    <div className='col-md-4'>
                        <p className='fs-5'><i class="fa fa-money mx-2" aria-hidden="true"></i>Funds</p>
                        <ul className='lh-lg' style={{lineHeight:"20px"}}>
                            <li >
                                <a href='' className='text-decoration-none'>Getting started</a>

                            </li>

                            <li>
                                <a href='' className='text-decoration-none'>Online</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Offline</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Charges</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Company, Partnership and HUF</a>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-4'>
                    <p className='fs-5'><i class="fa fa-plus-circle mx-2" aria-hidden="true"></i>Console</p>
                        <ul className='lh-lg' style={{lineHeight:"20px"}}>
                            <li >
                                <a href='' className='text-decoration-none'>Getting </a>

                            </li>

                            <li>
                                <a href='' className='text-decoration-none'>Online</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Offline</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Charges</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Company, Partnership and HUF</a>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-4'>
                    <p className='fs-5'><i class="fa fa-plus-circle mx-2" aria-hidden="true"></i> Coin</p>
                        <ul className='lh-lg' style={{lineHeight:"20px"}}>
                            <li >
                                <a href='' className='text-decoration-none'>Getting started</a>

                            </li>

                            <li>
                                <a href='' className='text-decoration-none'>Online</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Offline</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Charges</a>
                            </li>
                            <li>
                                <a href='' className='text-decoration-none'> Company, Partnership and HUF</a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </>
    );
}

export default CreateTiclet;